import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import BaseRootOption from "%/dynamic-component-editor/classes/base-root-option";

export default class DisplayName extends BaseRootOption {
  static userInterfaceComponent = {
    label: "Display Name",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = "";

  static validations = [
    value => {
      if (value.length > 32) {
        return "Name must be less than 24 characters long";
      }
    },
  ];
}
